<template>
  <CContainer class="d-flex flex-column justify-content-between py-5 content-center min-vh-100 col-12">
    <CRow class="col-12 d-flex flex-column justify-content-center align-content-center">
      <div class="col-6 align-self-center">
        <img src="../assets/fcm-logotipo.svg">
      </div>
      <CCol lg="6" sm="12">
        <CCard class="mb-0">
          <CCardBody>
            <CForm @submit.prevent="handleSubmit">
              <CInput placeholder="Email" autocomplete="username email" v-model="email" invalid-feedback="Please validate your email." :is-valid="validator">
                <template #prepend-content><CIcon name="cil-user"/></template>
              </CInput>
              <CInput  placeholder="Password" type="password" autocomplete="curent-password" v-model="password" invalid-feedback="Please validate your password." :is-valid="validator">
                <template #prepend-content><CIcon name="cil-lock-locked"/></template>
              </CInput>
              <CRow>
                <CCol col="6" class="text-left">
                  <CSpinner v-if="loading" variant="success" small></CSpinner>
                  <CButton v-else color="primary" class="px-4" @click="loginClicked">Login</CButton>
                </CCol>
                <CCol col="6" class="text-right">
                  <CButton color="link" class="d-md-none">Register now!</CButton>
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <TheFooter class="col-12"/>
  </CContainer>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import TheFooter from '../containers/TheFooter'


export default {
    components: {
    TheFooter
  },
  data () {
    return {
      email: '',
      password: '',
      loginError: '',
      submitted: false,
      loading: false
    }
  },
  computed:
  {
    ...mapState('alert', ['type']),
    ...mapState('alert', ['message']),
  },
  name: 'Login',
  methods: {
    ...mapActions('account', ['login']),
    ...mapActions({
          clearAlert: 'alert/clear' 
      }),
    loginClicked: function(){
      this.submitted = true;

      const { email, password } = this;
      if (email && password) {
        this.loading = true;
        this.login({ email, password })
      }
    },
    validator(val) 
    {
      var result = undefined; // This is the default, in case the user hasn't submitted yet

      if(this.submitted && (!val || this.loginError))
      {
        result = false;
      }

      return result;
    }
  },
  created: function()
  {
    this.clearAlert();
  },
  watch: 
  { 
    type: function()
    {
      this.loginError = this.type == "alert-danger" ? this.message : '';
      this.loading = false;
    },
    message: function()
    {
      this.loginError = this.type == "alert-danger" ? this.message : '';
      this.loading = false;
    },
    email: function()
    {
      this.loginError = '';
    },
    password: function()
    {
      this.loginError = '';
    }
  }
}
</script>
<style scoped>
img
{
  width: 100%;
}
</style>
